import { render, staticRenderFns } from "./EventsReport.vue?vue&type=template&id=2bd5d69a&scoped=true"
import script from "./EventsReport.vue?vue&type=script&lang=js"
export * from "./EventsReport.vue?vue&type=script&lang=js"
import style0 from "./EventsReport.vue?vue&type=style&index=0&id=2bd5d69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5d69a",
  null
  
)

export default component.exports